import { render, staticRenderFns } from "./LawEntityDetails.vue?vue&type=template&id=e2632fe6&scoped=true"
import script from "./LawEntityDetails.vue?vue&type=script&lang=js"
export * from "./LawEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./LawEntityDetails.vue?vue&type=style&index=0&id=e2632fe6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2632fe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2632fe6')) {
      api.createRecord('e2632fe6', component.options)
    } else {
      api.reload('e2632fe6', component.options)
    }
    module.hot.accept("./LawEntityDetails.vue?vue&type=template&id=e2632fe6&scoped=true", function () {
      api.rerender('e2632fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LawEntityDetails.vue"
export default component.exports